import ajax, { handleRedirect } from 'helpers/ajax';
import Routes from 'apps/portal/routes.erb';
import notify from '@fountain/ui-kit/components/notifications';
import types from './action-types';

export function resendConfirmationEmail(payload) {
  return (dispatch) => {
    dispatch({ type: types.RESEND_CONFIRMATION_EMAIL });

    return ajax({
      url: Routes.identity_confirmation_path({ format: 'json' }),
      method: 'POST',
      data: { identity: payload },
    })
      .then(handleRedirect)
      .then((response) => {
        dispatch({ type: types.RESEND_CONFIRMATION_EMAIL_RESULT });

        if (!response.data.redirectTo) {
          notify('Сonfirmation email sent', 'success');
        }
      })
      .catch(() => dispatch({ type: types.RESEND_CONFIRMATION_EMAIL_RESULT, error: true }));
  };
}
